import { SNACKBAR_DISPLAY, SNACKBAR_HIDE, SET_DEFAULT_PAGINATION } from '../constants/types'

export const displaySnackbar = (severity: string, message: string | string[], duration?: number, loggerMessage?: string) => (dispatch: any) => {
    dispatch({
        type: SNACKBAR_DISPLAY,
        payload: {
            severity,
            message,
            duration,
            loggerMessage
        },
    })
}

export const hideSnackbar = () => (dispatch: any) => {
    dispatch({
        type: SNACKBAR_HIDE,
    })
}

export const setDefaultPagination = (itemsPerPage: any) => (dispatch: any) => {
    dispatch({
        type: SET_DEFAULT_PAGINATION,
        payload: {
            itemsPerPage,
        },
    })
}
